import React from 'react'
import ReactDOM from 'react-dom'
import AerodynamicsCharts from '../src/javascripts/aerodynamics_charts';

const windOptions = {
  chart: {
    type: 'line',
  },
  title: {
    text: 'Wind Performance'
  },
  subtitle: {
     text: '.308 Caliber Claymore - 200 gr. (10 mph Wind)'
  },
  xAxis: {
    gridLineWidth: 1,
    title: {
      text: 'Muzzle Velocity (fps)'
    }
  },
  yAxis: {
    gridLineWidth: 1,
    title: {
      text: 'Wind Deflection (MOA)'
    }
  },
  tooltip: {
    headerFormat: "{point.key:.0f} fps<br>",
    pointFormat: "{point.y:.1f} MOA @ {series.name}"
  },
  series: [{"name":"600.0 yards","data":[[2000.0,5.839565622977852],[2100.0,5.383964529959384],[2200.0,4.991001798685117],[2300.0,4.651059711743956],[2400.0,4.353504281709171],[2500.0,4.0894946136260355],[2600.0,3.852473561984044],[2700.0,3.6376216065694607],[2800.0,3.441168956986528],[2900.0,3.259967164368318],[3000.0,3.091737132002753]]},{"name":"1000.0 yards","data":[[2000.0,11.223549519328387],[2100.0,10.51724061292156],[2200.0,9.777228410193977],[2300.0,9.071066170937035],[2400.0,8.44168438203997],[2500.0,7.883726018531573],[2600.0,7.3868875603061905],[2700.0,6.942057701008515],[2800.0,6.5412674896276455],[2900.0,6.1774937935341825],[3000.0,5.844974843917029]]}]
};

const stabilityOptions = {
  chart: {
    type: 'line',
  },
  title: {
    text: 'Gyroscopic Stability'
  },
  subtitle: {
     text: '.308 Caliber Claymore - 200 gr.'
  },
  xAxis: {
    gridLineWidth: 1,
    title: {
      text: 'Muzzle Velocity (fps)'
    }
  },
  yAxis: {
    gridLineWidth: 1,
    title: {
      text: 'Gyroscopic Stability Factor (Sg)'
    }
  },
  tooltip: {
    headerFormat: "{point.key:.0f} fps<br>",
    pointFormat: "SG: {point.y:.2f} @ {series.name}"
  },
  series: [{"name":"9.0 in/turn","data":[[2000.0,1.8296460375106094],[2100.0,1.8496986334769077],[2200.0,1.8679324044707515],[2300.0,1.8831118896410397],[2400.0,1.8965666539530264],[2500.0,1.9091983233613041],[2600.0,1.9211424675256035],[2700.0,1.9325065735990774],[2800.0,1.9433771335530758],[2900.0,1.9538246545072506],[3000.0,1.9639072772615416]]},{"name":"10.0 in/turn","data":[[2000.0,1.4820132903835936],[2100.0,1.498255893116295],[2200.0,1.513025247621309],[2300.0,1.5253206306092424],[2400.0,1.5362189897019514],[2500.0,1.5464506419226567],[2600.0,1.5561253986957388],[2700.0,1.5653303246152526],[2800.0,1.5741354781779917],[2900.0,1.582597970150873],[3000.0,1.5907648945818487]]},{"name":"11.0 in/turn","data":[[2000.0,1.2248043722178459],[2100.0,1.2382280108399133],[2200.0,1.2504340889432304],[2300.0,1.2605955624869771],[2400.0,1.2696024708280589],[2500.0,1.2780583817542615],[2600.0,1.2860540485088747],[2700.0,1.2936614253018615],[2800.0,1.3009384117173484],[2900.0,1.3079322067362589],[3000.0,1.314681731059379]]},{"name":"12.0 in/turn","data":[[2000.0,1.029175896099718],[2100.0,1.0404554813307605],[2200.0,1.050711977514798],[2300.0,1.0592504379230852],[2400.0,1.0668187428485774],[2500.0,1.0739240568907338],[2600.0,1.080642637983152],[2700.0,1.087034947649481],[2800.0,1.0931496376236054],[2900.0,1.0990263681603285],[3000.0,1.1046978434596173]]}]
};

const dragOptions = {
  chart: {
    type: 'spline',
  },
  title: {
    text: 'Drag Coefficient'
  },
  subtitle: {
   text: '.308 Caliber Claymore - 200 gr.'
  },
  xAxis: {
    gridLineWidth: 1,
    title: {
      text: 'Mach Number'
    }
  },
  yAxis: {
    gridLineWidth: 1,
    title: {
      text: 'Drag Coefficient'
    }
  },
  plotOptions: {
    spline: {
      marker: {enabled: true}
    }
  },
  tooltip: {
    headerFormat: "Mach {point.key:.2f}<br>",
    pointFormat: "{series.name} CD: {point.y:.2f}"
  },
  series: [{"name":"G1","data":[[0.5,0.09922952425081548],[0.6,0.09932719110539306],[0.7,0.10572437008022417],[0.8,0.12432990587725208],[0.85,0.14166577256477153],[0.9,0.1667661541912081],[0.925,0.1823440174963312],[0.95,0.1994357170474067],[0.975,0.2172110845805252],[1.0,0.23464461812262224],[1.1,0.2872870527399348],[1.2,0.3121921006572162],[1.3,0.32176345240581855],[1.4,0.32352145578821484],[1.5,0.3209821175691979],[1.6,0.31614760826760796],[1.7,0.30994576300193205],[1.8,0.30325558346336823],[2.0,0.28977755753166295],[2.2,0.27761803413675495],[2.5,0.2635540070775842],[3.0,0.2506619822733444],[3.5,0.24612047353548724],[4.0,0.2444601370076685],[4.5,0.2438497191665586],[5.0,0.2435811353164703]]},{"name":"G7","data":[[0.5,0.11485252048202495],[0.6,0.11485252048202495],[0.7,0.11562205160753264],[0.8,0.11946970723507115],[0.85,0.12562595623913278],[0.9,0.14082419596790996],[0.925,0.15967770854284874],[0.95,0.19757711647410317],[0.975,0.28790083233057007],[1.0,0.36581585878822515],[1.1,0.38611224222349083],[1.2,0.3736073614339907],[1.3,0.35898627004934425],[1.4,0.3443651786646979],[1.5,0.330898383968313],[1.6,0.3188744601322552],[1.7,0.30867817271927805],[1.8,0.29982856477593944],[2.0,0.28665034425162006],[2.2,0.2754921429317583],[2.5,0.25942818068678497],[3.0,0.23316793102883454],[3.5,0.2071962555429495],[4.0,0.1861303409821761],[4.5,0.1694411346977277],[5.0,0.1556376701339333]]},{"name":"Actual","data":[[0.5,0.1182879000317858],[0.6,0.11851128478609113],[0.7,0.11955017241486532],[0.8,0.121100598312997],[0.85,0.12198996778139638],[0.9,0.12764643777569315],[0.925,0.13889403285299207],[0.95,0.16375072299031915],[0.975,0.20962666503535562],[1.0,0.30265535252409836],[1.1,0.3381266589411356],[1.2,0.3428485573003495],[1.3,0.3439796798468381],[1.4,0.33915871876122183],[1.5,0.3296836391211573],[1.6,0.3202701910542143],[1.7,0.311409371320274],[1.8,0.3030469505831853],[2.0,0.2875661340109773],[2.2,0.2734543087496611],[2.5,0.2544455017189151],[3.0,0.22778074757875344],[3.5,0.20649004832671514],[4.0,0.18953738468407091],[4.5,0.17596077997075288],[5.0,0.16496979432224637]]}]
};

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <AerodynamicsCharts
      windOptions={windOptions}
      stabilityOptions={stabilityOptions}
      dragOptions={dragOptions}
     />,
    document.getElementById('clm_30_200_charts')
  );
});
